var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlatActionButton',{class:_vm.$style.dismissButton,attrs:{"action":_vm.handleButtonClick}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }